import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const MPLeclercIcon = (props) => {
  const themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        id="Leclerc"
        data-name="Leclerc"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 132.51 80.52"
        strokeWidth={0}
        fill="currentColor"
      >
        <title>Leclerc</title>
        <polygon
          fill={themeColor === 'light' ? '#0b70b5' : '#fff'}
          points="10.91 36.62 10.91 33.65 0 33.65 0 48.53 10.91 48.53 10.91 45.55 3.97 45.55 3.97 42.25 9.92 42.25 9.92 39.6 3.97 39.6 3.97 36.62 10.91 36.62"
        />
        <circle
          fill={themeColor === 'light' ? '#0b70b5' : '#fff'}
          cx="15.17"
          cy="46.79"
          r="2.1"
        />
        <polygon
          fill="#ed8b18"
          points="23.15 45.55 23.15 33.65 19.18 33.65 19.18 48.53 29.1 48.53 29.1 45.55 23.15 45.55"
        />
        <rect
          fill={themeColor === 'light' ? '#0b70b5' : '#fff'}
          x="58.21"
          y="33.65"
          width="3.64"
          height="14.88"
        />
        <path
          fill={themeColor === 'light' ? '#0b70b5' : '#fff'}
          d="m117.35,55.43c-8.36,0-15.16-6.8-15.16-15.16s6.8-15.16,15.16-15.16,15.16,6.8,15.16,15.16c0,8.36-6.8,15.16-15.16,15.16Zm0-27.12c-6.59,0-11.96,5.36-11.96,11.96s5.36,11.96,11.96,11.96,11.96-5.36,11.96-11.96-5.36-11.96-11.96-11.96Z"
        />
        <path
          fill={themeColor === 'light' ? '#0b70b5' : '#fff'}
          d="m82.02,38.32v-1.7h-3.64v11.91h3.64v-5.91c0-1.19.66-3.58,3.64-2.91v-3.1s-1.98-.53-3.64,1.72Z"
        />
        <path
          fill={themeColor === 'light' ? '#0b70b5' : '#fff'}
          d="m120.56,44.23s-.61,1.65-3.04,1.65h-2.09v-8.9c0-.7.61-1.35,1.3-1.35h.02v-1.98h-6.28v1.98h-.02c.7,0,1.34.65,1.34,1.35v7.56c0,.7-.64,1.35-1.34,1.35h.02v2.98h11.58v-4.63h-1.48Z"
        />
        <path
          fill="#ed8b18"
          d="m118.9,30.74c-1.84,0-3.54.59-4.92,1.59h4.09v4.21c-.99.15-1.32.82-1.32,1.63v6.4h1.16c1.07,0,1.93-.66,1.99-1.65h3.47v3.04c2.32-1.48,3.77-4.04,3.77-6.93,0-4.57-3.66-8.29-8.23-8.29Z"
        />
        <path
          fill={themeColor === 'light' ? '#0b70b5' : '#fff'}
          d="m36,46.39c-2.13,0-2.66-.84-2.72-3.16h8.68c0-5.29-.71-6.67-5.97-6.67s-5.9,1.85-5.9,6.13c0,4.62,1,6.11,5.89,6.11,3.65,0,5.97-.27,5.97-3.91h-3.28c-.26,1.32-1.24,1.5-2.68,1.5Zm0-7.35c1.89,0,2.5.55,2.69,2.21h-5.34c.18-1.65.79-2.21,2.66-2.21Z"
        />
        <path
          fill={themeColor === 'light' ? '#0b70b5' : '#fff'}
          d="m70.16,46.39c-2.13,0-2.66-.84-2.72-3.16h8.68c0-5.29-.71-6.67-5.97-6.67s-5.9,1.85-5.9,6.13c0,4.62,1,6.11,5.89,6.11,3.65,0,5.97-.27,5.97-3.91h-3.28c-.26,1.32-1.24,1.5-2.68,1.5Zm0-7.35c1.89,0,2.5.55,2.69,2.21h-5.34c.18-1.65.79-2.21,2.66-2.21Z"
        />
        <path
          fill={themeColor === 'light' ? '#0b70b5' : '#fff'}
          d="m94.91,44.23c-.07.66-.24,1.17-.55,1.45-.4.39-1.04.42-1.97.42-2.04,0-2.53-.81-2.53-3.5,0-2.31.36-3.48,2.53-3.48,1.32,0,2.27.14,2.5,1.79h3.34c-.08-3.97-2.44-4.4-5.87-4.4-4.97,0-5.8,2.05-5.8,6.09,0,4.69,1.11,6.07,5.8,6.07,2.15,0,3.6-.06,4.53-.74.9-.62,1.3-1.73,1.34-3.71h-3.32Z"
        />
        <path
          fill={themeColor === 'light' ? '#0b70b5' : '#fff'}
          d="m52.63,44.23c-.07.66-.24,1.17-.55,1.45-.4.39-1.04.42-1.97.42-2.04,0-2.53-.81-2.53-3.5,0-2.31.36-3.48,2.53-3.48,1.32,0,2.27.14,2.5,1.79h3.34c-.08-3.97-2.44-4.4-5.87-4.4-4.97,0-5.8,2.05-5.8,6.09,0,4.69,1.11,6.07,5.8,6.07,2.15,0,3.61-.06,4.53-.74.9-.62,1.3-1.73,1.34-3.71h-3.32Z"
        />
      </svg>
    </SvgIcon>
  );
};

export default MPLeclercIcon;
